import UserModel from '@/models/User';

const GET_ADDRESS_LIST = 'GET_ADDRESS_LIST';
const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
const CLEAR_SELECTED_ADDRESS = 'CLEAR_SELECTED_ADDRESS';
const UPDATE_DEFAULE_ADDRESS = 'UPDATE_DEFAULE_ADDRESS';

/**
 * 获取收货地址列表
 */
async function getAddressList() {
  const payload = await new UserModel().addressList();
  return {
    type: GET_ADDRESS_LIST,
    payload
  }
}

/**
 * 设置选中的地址信息
 * @param {Object} addressInfo 地址信息
 */
async function setSelectedAddress(addressInfo) {
  return {
    type: SET_SELECTED_ADDRESS,
    payload: addressInfo
  }
}

/**
 * 清除选中的地址信息
 */
async function clearSelectedAddress() {
  return {
    type: CLEAR_SELECTED_ADDRESS,
    payload: {}
  }
}

/**
 * 默认收货地址修改
 */
async function updateDefauleAddress(params) {
  const payload = await new UserModel().updateDefauleAddress(params);
  return {
    type: UPDATE_DEFAULE_ADDRESS,
    payload
  }
}

const ACTION_TYPES = {
  GET_ADDRESS_LIST,
  SET_SELECTED_ADDRESS,
  CLEAR_SELECTED_ADDRESS,
  UPDATE_DEFAULE_ADDRESS,
};

const ACTION = {
  getAddressList,
  setSelectedAddress,
  clearSelectedAddress,
  updateDefauleAddress,
};

const AddressList = {
  ACTION_TYPES,
  ACTION
}

export default AddressList;